export default "__VITE_ASSET__CwlkDt2u__"